import SectionLabel from "@/components/base/SectionLabel";
import { pricingData } from "@/mocks/pricingData";

export default function MaintenanceSection() {
  return (
    <section id="maintenance" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="reveal text-center mb-10 md:mb-14">
          <SectionLabel label={pricingData.maintenance.label} className="mb-3" />
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900">
            {pricingData.maintenance.title}
          </h2>
        </div>

        <div className="reveal max-w-3xl mx-auto">
          <div className="text-center mb-5">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed max-w-xl mx-auto mb-4">
              {pricingData.maintenance.description}
            </p>
            <div className="inline-flex px-4 py-2.5 rounded-full bg-accent-100 border border-accent-200/60">
              <span className="text-sm md:text-base font-bold text-accent-700">
                {pricingData.maintenance.pricing}
              </span>
            </div>
          </div>

          <div className="bg-background-100 rounded-lg border border-background-200/70 p-6 md:p-8 mb-6 mt-7">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {pricingData.maintenance.items.map((item, i) => (
                <div key={i} className="flex items-center gap-3 p-2.5 rounded-md bg-background-50 border border-background-200/50">
                  <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-primary-600 text-sm`} />
                  </div>
                  <span className="text-sm md:text-base text-foreground-700">{item.label}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-background-100 rounded-lg p-4 md:p-5 border border-background-200/70">
            <div className="flex items-start gap-2.5">
              <i className="ri-information-line text-primary-500 mt-0.5" />
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {pricingData.maintenance.note}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}